var React = require('react');

function SelectedRadio (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z","fill":"black","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.4995 13.1304L14.8995 19.8504L11.4995 16.2804L12.6095 15.2204L14.8195 17.5404L19.3095 12.1504L20.4895 13.1304H20.4995Z","fill":"white","key":1})]);
}

SelectedRadio.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = SelectedRadio;

SelectedRadio.default = SelectedRadio;
